import React from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { func, number, string, bool } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/icons';
import { Dropdown } from '@fiverr-private/orca';
import dynamicTranslations from '../../../../../utils/translation/DynamicTranslationService';

const Entry = ({ industryKey = null, value = 0, onClick = noop, selected = false, children }) => (
    <Dropdown.MenuItem onClick={() => onClick(industryKey)}>
        {selected && (
            <Icon size={12} className="industry-selected-icon">
                {r_check}
            </Icon>
        )}
        <span className={classNames('industry-entry', { 'industry-selected': selected })}>
            {children ? (
                children
            ) : (
                <>
                    {dynamicTranslations.getIndustryTranslation(industryKey)} ({value})
                </>
            )}
        </span>
    </Dropdown.MenuItem>
);

Entry.propTypes = {
    industryKey: string,
    value: number,
    selected: bool,
    onClick: func,
};

export default Entry;
